<template>
  <div class="page flex">
        <el-col :span='4' style='margin-top:-20px;margin-bottom:10px'><el-button type="warning" @click="popBack" 
        size='small' icon='el-icon-back'>返回</el-button></el-col>
        <el-form :model='form' class='flexForm' :rules="rules" ref='form'>
            <el-row>
                <el-col :span='5'>&nbsp;</el-col>
            <el-col :span='12'>
                <el-form-item label='手机状态：' label-width="100px" prop="mobileStatus">
                    <el-select v-model='form.mobileStatus '>
                        <el-option v-for='item in status' :key='item.label' :label='item.label' :value='item.value'></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            </el-row>
            <el-row>
                <el-col :span='5'>&nbsp;</el-col>
                <el-col :span='12'>
                    <el-form-item label='回访原因：' label-width="100px" prop='visitCause'>
                        <el-radio v-model='form.visitCause' label='注册未实名'>注册未实名</el-radio>
                        <el-radio v-model='form.visitCause' label='实名未绑卡'>实名未绑卡</el-radio>
                        <el-radio v-model='form.visitCause' label='绑卡未申请'>绑卡未申请</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span='5'>&nbsp;</el-col>
                <el-col :span='12'>
                    <el-form-item label='回访时间：' label-width="100px" prop='visitDate'>
                        <el-date-picker v-model='form.visitDate' type='datetime' value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span='5'>&nbsp;</el-col>
                <el-col :span='12'>
                    <el-form-item label='回访结果：' label-width="100px" prop='visitResult'>
                        <el-input type='textarea' v-model='form.visitResult' width='60%'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span='5'>&nbsp;</el-col>
                <el-form-item label='.' label-width="100px">
                    <el-button type='primary' @click="submit">保存记录</el-button>
                </el-form-item>
            </el-row>
            
        </el-form>
  </div>
</template>

<script>
import userInfo from '@/components/userInfo.vue'
import { store } from '@/util/observable.js'
  export default {
    data () {
      return {
          form: {},
          dataList: [],
          title: '新增用户',
          visible: false,
          params: {},
          roleNames: [],
          current:1,
          total:0,
          status:[
              {label:'正常',value:'正常'},
              {label:'关机',value:'关机'},
              {label:'停机',value:'停机'},
              {label:'挂断',value:'挂断'},
              {label:'空号',value:'空号'},
              {label:'通话中',value:'通话中'},
              {label:'无法接通',value:'无法接通'},
              {label:'无人接听',value:'无人接听'},
          ],
          rules:{
            mobileStatus:[
                    {trigger: 'change',required:true,message:'请选择手机状态'}
                ],
            visitCause:[
                {trigger: 'change',required:true,message:'请选择回访原因'}
            ],
            visitDate:[
                {trigger: 'change',required:true,message:'请选择回访时间'}
            ],
            visitResult:[
                {trigger: 'blur',required:true,message:'请输入回访结果'}
            ]
          }
      }
    },
    props:{
        back:{default: null}
    },
    components: {
        userInfo
    },
   methods: {
       async submit(){
           if(!await this.$check(this.$refs['form'].validate)) return 
           let params = {
               userId: store.userId,
               ...this.form
           }
           const rsp = await this.$http.newRecord(params)
           if(rsp.code != 200) return
           this.$message({message:'操作成功！',type:'success'})
           this.popBack({status:1})
       },
       
       close(){
           this.visible = false
           this.getUser()
       },
       popBack({status=0}){
           this.$emit('back',status)
       }
   },
   created(){
   }
    }
</script>

<style scoped >
.page{flex-direction: column;}
 
</style>
